@if (type === "dashboard") {
  <header
    id="header"
    class="app-header d-flex align-items-center justify-content-between ps-5 pe-4"
  >
    <div class="d-md-none flex-shrink-0">
      <a href="/home" class="brand">
        @if (rvsfDetails()?.rvsf_logo_path) {
          <img [src]="rvsfDetails()?.rvsf_logo_path" alt="" />
        } @else {
          <img src="logos/logo-mini-color.png" alt="" />
        }
      </a>
    </div>
    <!-- search removed as discussed  -->
    @if (false) {
      <div
        class="search-control py-3 ps-5 pe-4 p-md-0"
        [ngClass]="isMobileSearch ? 'd-flex' : 'd-none'"
      >
        <div class="form-control form-control-sm">
          <i
            class="ph-duotone ph-magnifying-glass text-opacity-50 text-dark fs-6"
          ></i>
          <input type="text" placeholder="Search Shop" />
        </div>
        <a
          role="button"
          class="d-md-none text-opacity-75 ms-2 text-dark"
          (click)="isMobileSearch = false"
        >
          <i class="ph ph-x fs-6"></i>
        </a>
      </div>
    }

    <!-- Right side header -->
    <div class="d-flex align-items-center gap-2 gap-sm-3 ms-auto">
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-link btn-sm px-0 text-body-secondary text-decoration-none fw-medium"
          id="branch_selection"
          ngbDropdownToggle
        >
          <span>{{
            selectedBranch ? selectedBranch.branch_name : "Select Branch"
          }}</span>
          <i class="ph ph-caret-down fs-7"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="branch_selection">
          @for (item of branchList(); track item.branch_id) {
            <button ngbDropdownItem (click)="setSelectedBranch(item)">
              {{ item.branch_name }}
            </button>
          }
        </div>
      </div>
      @if (false) {
        <button
          class="btn btn-sm btn-icon btn-ghost-light rounded-pill d-md-none"
          (click)="isMobileSearch = true"
        >
          <i class="ph-duotone ph-magnifying-glass fs-6"></i>
        </button>
      }
      <button
        class="btn btn-sm btn-icon btn-ghost-light rounded-circle position-relative"
        (click)="openNotifications()"
        title="Notifications"
      >
        <i class="ph ph-bell fs-5"></i>
        @if (unreadCount() > 0) {
          <span
            class="position-absolute badge rounded-pill bg-danger border border-1 border-white"
            style="
              top: -2px;
              right: -2px;
              font-size: 0.65rem;
              padding: 0.25em 0.45em;
              line-height: 1;
            "
          >
            {{ unreadCount() > 99 ? "99+" : unreadCount() }}
          </span>
        }
      </button>
      <div ngbDropdown class="d-inline-block">
        <a
          role="button"
          class="text-decoration-none fw-medium"
          id="user_profile"
          ngbDropdownToggle
        >
          <div class="avatar avatar--pill">
            <div class="avatar__image">
              <img [src]="userAvatar" alt="User" />
            </div>
          </div>
        </a>
        <div ngbDropdownMenu aria-labelledby="user_profile">
          <div class="px-3 py-2 border-bottom bg-light">
            <!-- <div class="fw-semibold text-dark">Login User</div> -->
            <small class="text-muted">{{ user?.full_name }}</small>
          </div>
          <a
            ngbDropdownItem
            routerLink="/home/profile"
            class="d-flex align-items-center gap-2"
          >
            <i class="ph ph-user fs-6"></i>
            <span>Profile</span>
          </a>
          <button ngbDropdownItem class="text-danger" (click)="logout()">
            Logout
          </button>
        </div>
      </div>
    </div>
  </header>
} @else {
  <header id="header" class="py-3">
    <div class="container d-flex align-items-center">
      <a href="/" class="brand">
        @if (rvsfDetails()?.rvsf_logo_path) {
          <img [src]="rvsfDetails()?.rvsf_logo_path" alt="" />
        } @else {
          <img src="/logos/logo.png" class="d-none d-md-block" alt="MMCM" />
        }
        <!-- <img src="/logos/logo-mini.png" class="d-md-none" alt="MMCM" /> -->
      </a>
      <div class="gap-2 d-flex ms-auto">
        <button
          type="button"
          class="btn btn-mobile-icon btn-sm btn-shadow btn-primary"
          [routerLink]="['/contact-us']"
        >
          <i class="ph ph-headset fs-6"></i>
          <span class="d-sm-inline-block d-none">Contact Us</span>
        </button>
        <a href="#" class="btn btn-sm btn-outline-white">
          <span>English</span>
          <i class="ph ph-caret-down fs-6"></i>
        </a>
      </div>
    </div>
  </header>
}
